import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Gift, ShoppingCart } from 'lucide-react';

import { WizardOptionCard } from './WizardOptionCard';
import type { CheckoutStyle, QuickstartAnswers } from './types';

interface StepCheckoutStyleProps {
    answers: QuickstartAnswers;
    onChange: (next: Partial<QuickstartAnswers>) => void;
}

export function StepCheckoutStyle({ answers, onChange }: StepCheckoutStyleProps) {
    const { t } = useTranslation('common');
    const select = (value: CheckoutStyle) => onChange({ checkoutStyle: value });

    // Preselect the first option ("Classic") on mount.
    React.useEffect(() => {
        if (answers.checkoutStyle === null) {
            onChange({ checkoutStyle: 'classic' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex flex-col gap-4">
            <div>
                <h3 className="text-lg font-semibold">
                    {t('funnelQuickstart.checkoutStyle.title')}
                </h3>
                <p className="text-muted-foreground text-sm">
                    {t('funnelQuickstart.checkoutStyle.subtitle')}
                </p>
            </div>

            <div className="flex flex-col gap-3">
                <WizardOptionCard
                    title={t('funnelQuickstart.checkoutStyle.classic.title')}
                    description={t('funnelQuickstart.checkoutStyle.classic.description')}
                    icon={<ShoppingCart className="h-5 w-5" />}
                    selected={answers.checkoutStyle === 'classic'}
                    onSelect={() => select('classic')}
                />
                <WizardOptionCard
                    title={t('funnelQuickstart.checkoutStyle.bogo.title')}
                    description={t('funnelQuickstart.checkoutStyle.bogo.description')}
                    icon={<Gift className="h-5 w-5" />}
                    selected={answers.checkoutStyle === 'bogo'}
                    onSelect={() => select('bogo')}
                />
            </div>
        </div>
    );
}
